import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import React from 'react';

// import { MASTER_ENDPOINT } from 'utils/Constant';
import UserAssignModal from './UserAssignModal';
import { JobData, JobUserAssigned, User } from './utils';

type AssignUserListProps = {
  users: User[];
  row: JobData;
};

const AssignUserList: React.FC<AssignUserListProps> = React.memo(
  ({ users, row }) => {
    const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
    const [assignModalOpen, setAssignModalOpen] = React.useState(false);
    const [selectedJobId, setSelectedJobId] = React.useState<string>('');
    const [selectedJobTitle, setSelectedJobTitle] = React.useState<string>('');
    const [assignedUsers, setAssignedUsers] = React.useState<JobUserAssigned[]>(
      row.usersAssigned || [],
    );

    // Memoize assignedUsers to avoid unnecessary re-renders unless row.usersAssigned changes
    React.useEffect(() => {
      setAssignedUsers(row.usersAssigned || []);
    }, [row.usersAssigned]);

    const handleAssignUser = React.useCallback(
      (jobData: JobData, anchorEl: HTMLElement | null) => {
        setAnchorEl(anchorEl);
        setSelectedJobId(jobData.id);
        setAssignedUsers(jobData.usersAssigned || []);
        setAssignModalOpen(true);
      },
      [],
    );

    const handleCloseAssignModal = React.useCallback(() => {
      setAssignModalOpen(false);
      setSelectedJobId('');
      setSelectedJobTitle('');
      setAnchorEl(null);
    }, []);

    const handleUserAssignment = React.useCallback(
      (userId: string, type: 'add' | 'remove') => {
        setAnchorEl(null);
        // Here you would typically make an API call to assign the user to the job
        if (type === 'remove') {
          setAssignedUsers((prev) =>
            prev.filter((user) => user.userId !== userId),
          );
          handleCloseAssignModal();
          return;
        }
        const userInfo = users.find((user) => user.id === userId);
        if (userInfo) {
          const newAssignedUser: JobUserAssigned = {
            assignedByFirstName: '',
            assignedByImageId: '',
            assignedByLastName: '',
            assignedByUserName: '',
            assignedToFirstName: userInfo?.firstName,
            assignedToImageId: userInfo?.imageId || null,
            assignedToLastName: userInfo?.lastName,
            assignedToUserName: userInfo?.firstName + ' ' + userInfo?.lastName,
            createdBy: userInfo.createdBy,
            id: userId,
            jobId: selectedJobId,
            userId: userId,
          };
          setAssignedUsers((prev) => [...prev, newAssignedUser]);
          handleCloseAssignModal();
        }
      },
      [users, selectedJobId, handleCloseAssignModal],
    );

    return (
      <div
        style={{
          alignItems: 'center',
          display: 'flex',
        }}
        onClick={(e) => {
          e.stopPropagation();
          handleAssignUser(row, e.currentTarget);
        }}>
        {assignedUsers && assignedUsers.length > 0 ? (
          <>
            {assignedUsers.map((user, index) => {
              const avatarColors = ['#EBF0FF', '#FFEBEB'];
              const bgColor = avatarColors[index % avatarColors.length];
              return (
                <div
                  key={user.id}
                  style={{
                    alignItems: 'center',
                    backgroundColor: '#ffffff',
                    border: '1px solid #e5e7eb',
                    borderRadius: '6px',
                    display: 'flex',
                    flexShrink: 0,
                    fontFamily: 'Red Hat Display Medium',
                    fontSize: '10px',
                    fontWeight: '500',
                    height: '28px',
                    justifyContent: 'center',
                    marginLeft: index > 0 ? '-6px' : '0',
                    overflow: 'hidden',
                    width: '28px',
                  }}>
                  {
                    // user?.assignedToImageId ? (
                    //   <div
                    //     style={{
                    //       alignItems: 'center',
                    //       borderRadius: '50%',
                    //       display: 'flex',
                    //       height: '22px',
                    //       overflow: 'hidden',
                    //       width: '24px',
                    //     }}>
                    //     <img
                    //       style={{
                    //         borderRadius: '50%',
                    //         color: 'transparent',
                    //         height: '24px',
                    //         objectFit: 'cover',
                    //         overflow: 'hidden',
                    //         textAlign: 'center',
                    //         textIndent: '10000px',
                    //         width: '24px',
                    //       }}
                    //       alt=""
                    //       src={`${process.env.REACT_APP_APIURL}${
                    //         MASTER_ENDPOINT.Files
                    //       }/${String(user?.assignedToImageId)}`}
                    //       loading="lazy"
                    //     />
                    //   </div>
                    // ) :
                    <span
                      style={{
                        alignItems: 'center',
                        backgroundColor: bgColor,
                        borderRadius: '6px',
                        display: 'flex',
                        height: '25px',
                        justifyContent: 'center',
                        width: '25px',
                      }}>
                      {user?.assignedToFirstName?.charAt(0).toUpperCase() || ''}
                      {user?.assignedToLastName?.charAt(0).toUpperCase() || ''}
                    </span>
                  }
                </div>
              );
            })}

            <button
              style={{
                alignItems: 'center',
                backgroundColor: '#EFEFEF',
                border: '1px solid #e5e7eb',
                borderRadius: '4px',
                color: '#6b7280',
                cursor: 'pointer',
                display: 'flex',
                flexShrink: 0,
                fontSize: '12px',
                height: '24px',
                justifyContent: 'center',
                marginLeft: '-6px',
                width: '24px',
              }}>
              <AddCircleOutlineIcon sx={{ fontSize: '12px' }} />
            </button>
          </>
        ) : (
          <div
            style={{
              alignItems: 'center',
              backgroundColor: '#f3f4f6',
              border: '1px solid #e5e7eb',
              borderRadius: '4px',
              display: 'flex',
              gap: '4px',
              paddingRight: '4px',
            }}>
            <button
              style={{
                alignItems: 'center',
                backgroundColor: '#f3f4f6',
                border: 'none',
                borderRadius: '4px',
                borderRight: '1.5px solid #e5e7eb',
                color: '#6b7280',
                cursor: 'pointer',
                display: 'flex',
                flexShrink: 0,
                fontSize: '12px',
                height: '24px',
                justifyContent: 'center',
                width: '24px',
              }}>
              <PersonAddIcon sx={{ fontSize: '12px' }} />
            </button>
            <ExpandMoreIcon sx={{ fontSize: '12px' }} />
          </div>
        )}
        {/* User Assign Modal */}
        <UserAssignModal
          open={assignModalOpen}
          onClose={handleCloseAssignModal}
          onAssignUser={handleUserAssignment}
          jobId={selectedJobId}
          jobTitle={selectedJobTitle}
          anchorEl={anchorEl}
          users={users}
          exisitngAssignedUsers={assignedUsers}
        />
      </div>
    );
  },
);

export default AssignUserList;
